import { fromJS, List, Map } from 'immutable';
import { dispatch, parametric, pathSubscription, subscription } from 'nike-re-framejs';
import axios from 'axios';
import { sortHeadersEnabledFirst } from '../utils';

const getStatsUrl = () =>
    window.OPTIONS.properties
        ? window.OPTIONS.properties['stats2.endpoint.url']
        : window.OPTIONS.player['stats2Endpoint'];

const getLang = () => window.OPTIONS.locale || window.OPTIONS.lang;

const marketStatsLoaded = (matchId, data) => db =>
    db.setIn(['market-statistics', 'matches', `${matchId}`, 'match'], data);

export const initializeMarketStatistics = (matchId, gameType) => db => {
    axios
        .get(`${getStatsUrl()}/market-statistics/${matchId}`, {
            params: { gameType: gameType, lang: getLang() }
        })
        .then(data => {
            dispatch(marketStatsLoaded(matchId, fromJS(data)));
            dispatch(groupByHeaders(matchId, fromJS(data?.bets)));
        });
    return db;
};

export const setAvailableSports = data => db => {
    const { sports } = data;
    const sportArray = sports.map(sport => sport.sportId);
    return db.setIn(['market-statistics', 'availableSports'], List(sportArray).sort());
};
export const bets$$ = parametric(matchId =>
    subscription(db => db.getIn(['market-statistics', 'matches', `${matchId}`, 'match', 'bets']))
);

export const marketStatsBetbookBets$ = parametric(matchId =>
    subscription(db => db.getIn(['market-statistics', 'betbook', matchId, 'bets']))
);

export const hasSportsMarketStats$ = subscription(db => db.getIn(['market-statistics', 'availableSports']));

export const prematchMarketStats$$ = parametric(matchId =>
    subscription(
        match =>
            '' + match?.get('matchId') === matchId &&
            match
                .get('bets')
                .filter(bet => bet.get('selections').some(s => s.get('enabled')))
                .groupBy(b => b.get('marketId')),
        pathSubscription(['market-statistics', 'matches', matchId, 'match'])
    )
);

export const liveMatchMarketStats$$ = parametric(matchId =>
    subscription(
        (statBets, tlvBets) =>
            tlvBets &&
            statBets?.filter(statBet => tlvBets.find(tlvBet => tlvBet.get('id') === '' + statBet.get('betId'))),
        pathSubscription(['market-statistics', 'matches', `${matchId}`, 'match', 'bets']),
        pathSubscription(['turboLive', 'detail', 'bets'])
    )
);

export const getOddsFromTlv$$ = parametric((betId, code) =>
    subscription(selections => {
        const selection = selections?.find(sel => sel.get('code') === code);
        return selection?.get('odds');
    }, pathSubscription(['turboLive', 'detail', 'bets', betId, 'selections']))
);

export const getBetStateFromTlv$ = betId => pathSubscription(['turboLive', 'detail', 'bets', betId, 'state'], false);

export const byHeaders$$ = parametric(matchId =>
    subscription(
        (headers, bets) => {
            if (headers && bets)
                // sorting headers - enabled first then disabled
                return sortHeadersEnabledFirst(headers, bets);
            else return headers;
        },
        pathSubscription(['market-statistics', 'matches', `${matchId}`, 'byHeaders']),
        pathSubscription(['turboLive', 'detail', 'bets'], false)
    )
);

export const byHeadersBB$$ = parametric(matchId =>
    subscription(db => db.getIn(['market-statistics', 'matches', `${matchId}`, 'byHeaders']))
);

export const removeMarketStats = matchId => db => {
    return db.removeIn(['market-statistics', 'matches', `${matchId}`]);
};

export const groupByHeaders = (matchId, bets) => db => {
    const reducedHeaders = bets?.reduce((acc, val) => [...acc, val.get('betHeaderDetail')], []);
    if (!reducedHeaders) {
        return db;
    }
    const betHeaders = reducedHeaders.filter((val, index) => {
        return reducedHeaders.indexOf(val) === index;
    });
    db = db.setIn(['market-statistics', 'matches', `${matchId}`, 'byHeaders'], List());
    betHeaders?.map(
        header =>
            (db = db.updateIn(['market-statistics', 'matches', `${matchId}`, 'byHeaders'], old =>
                old.push(Map({ header: header, betIds: getListOfBetIdsByHeader(bets, header) }))
            ))
    );
    return db;
};

function getListOfBetIdsByHeader(bets, header) {
    return bets.filter(bet => bet.get('betHeaderDetail') === header).map(bet => bet.get('betId'));
}

export const findBetByBetId = (bets, betId) => {
    return bets.find(o => o.get('betId') === betId);
};
